import React, { useState } from 'react';
import Rodal from '../../../components/Rodal/Rodal';
import { ModalBody, ModalHeader, Row } from 'reactstrap';
import './NdaTermsPopup.scss';
import { useStateSelector } from '../../../store/selectors';
import createNotification from '../../../utils/createNotification';
import { DataNdaTermsType } from '../../../slices/marketplace/timeline/models/enums/data-nda-term-type';
import { NdaTerms } from '../../../slices/marketplace/timeline/models/nda-term-model';
import ButtonLoader from '../../../components/Layout/Buttons/ButtonLoader';

interface LockInPopupProps {
    isVisible: boolean;
    isFinalLockIn: boolean;
    setIsVisible(value: boolean): void;
    ndaTermSelectionId: string;
    engagementId: number;
    fetchData(): void;
    lastSellerSelection: NdaTerms;
}

export const LockInPopup = (props: LockInPopupProps) => {
    const axios = useStateSelector((state) => state.core.axios);
    const [isLoading, setIsLoading] = useState(false);

    const lockInTerms = () => {
        setIsLoading(true);

        const requestUrl = props.isFinalLockIn
            ? `/api/Marketplace/${props.engagementId}/MarketplaceEventActions/LockInNdaTerm/${props.ndaTermSelectionId}/final`
            : `/api/Marketplace/${props.engagementId}/MarketplaceEventActions/LockInNdaTerm/${props.ndaTermSelectionId}`;

        axios
            .post(requestUrl)
            .then((response) => {
                if (response.status !== 200) {
                    createNotification(
                        'Something went wrong during saving locking terms',
                        'error'
                    );
                }
            })
            .finally(() => {
                setIsLoading(false);
                props.fetchData();
                props.setIsVisible(false);
            });
    };

    const formatYears = (type: DataNdaTermsType) => {
        if (type === DataNdaTermsType.OneYear) return '1 Year';
        if (type === DataNdaTermsType.NA) return 'N/A';

        const string = type.toString();

        return `${string} Years`;
    };

    const buyersLockInfoText =
        'All buyers which are in agreement will be sent the Data NDA to execute. Any buyers NOT in agreement will not receive an NDA.';
    const finalLockInfoText =
        'All buyers wich is NOT in agreement will be sent the Data NDA to execute with your lates terms selections.';

    const buersLockHeaderText = 'Send NDA to Parties in Agreement';
    const finalLockHeaderText = 'Send NDA to all Remaining Parties';

    return (
        <>
            <Rodal
                visible={props.isVisible}
                onClose={() => props.setIsVisible(false)}
                animation="slideUp"
                className="data-nda-terms-popup"
                showMask={true}
                width={400}
                showCloseButton={true}>
                <ModalHeader>
                    {props.isFinalLockIn
                        ? finalLockHeaderText
                        : buersLockHeaderText}
                </ModalHeader>
                <ModalBody>
                    <div className="data-nda-terms-lock-in-popup">
                        <Row>
                            {props.isFinalLockIn
                                ? finalLockInfoText
                                : buyersLockInfoText}
                        </Row>
                        <Row className="mt-3 selections-header">
                            Term Selections:
                        </Row>
                        <Row>
                            <label className="mr-1 mt-1 ml-2">
                                Non-Disclosure Period:{' '}
                                <span className="period-value">
                                    {props.lastSellerSelection
                                        .nonDisclosurePeriod != null
                                        ? formatYears(
                                              props.lastSellerSelection
                                                  .nonDisclosurePeriod
                                          )
                                        : 'NA'}
                                </span>
                            </label>
                        </Row>
                        <Row>
                            <label className="mr-1 ml-2">
                                Non-Solicitation Period
                            </label>
                        </Row>
                        <Row>
                            <div className="non-solicitation-period">
                                <div className="sub-title">
                                    <label className="mr-1 ml-3">
                                        DVMs / Management
                                    </label>
                                    <label className="mr-1 ml-4">
                                        Names Visible:{' '}
                                        <span className="period-value">
                                            {props.lastSellerSelection
                                                .nonSolicitationDvmNamesVisible !=
                                            null
                                                ? formatYears(
                                                      props.lastSellerSelection
                                                          .nonSolicitationDvmNamesVisible
                                                  )
                                                : 'NA'}
                                        </span>
                                    </label>
                                    <label className="mr-1 ml-4">
                                        Names Blinded:{' '}
                                        <span className="period-value">
                                            {props.lastSellerSelection
                                                .nonSolicitationDvmNamesBlinded !=
                                            null
                                                ? formatYears(
                                                      props.lastSellerSelection
                                                          .nonSolicitationDvmNamesBlinded
                                                  )
                                                : 'NA'}
                                        </span>
                                    </label>
                                </div>
                                <div className="sub-title">
                                    <label className="mr-1 ml-3">Staff</label>
                                    <label className="mr-1 ml-4">
                                        Names Visible:{' '}
                                        <span className="period-value">
                                            {props.lastSellerSelection
                                                .nonSolicitationStaffNamesVisible !=
                                            null
                                                ? formatYears(
                                                      props.lastSellerSelection
                                                          .nonSolicitationStaffNamesVisible
                                                  )
                                                : 'NA'}
                                        </span>
                                    </label>
                                    <label className="mr-1 ml-4">
                                        Names Blinded:{' '}
                                        <span className="period-value">
                                            {props.lastSellerSelection
                                                .nonSolicitationStaffNamesBlinded !=
                                            null
                                                ? formatYears(
                                                      props.lastSellerSelection
                                                          .nonSolicitationStaffNamesBlinded
                                                  )
                                                : 'NA'}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className="buttons-wrapper">
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={() => props.setIsVisible(false)}>
                                    Cancel & Close
                                </button>

                                <ButtonLoader
                                    buttonText={'Send NDA'}
                                    disabled={false}
                                    isLoading={isLoading}
                                    onClick={() => {
                                        lockInTerms();
                                    }}
                                    className={'btn btn-primary loader-submit'}
                                    loaderButtonText={''}
                                />
                            </div>
                        </Row>
                    </div>
                </ModalBody>
            </Rodal>
        </>
    );
};
